const isSingleItem = (item) => !Array.isArray(item);
export {
  isSingleItem
};
//# sourceMappingURL=isSingleItem.mjs.map
